window.__wpcal_client_end = "admin";

export default {
  __dummy_cliend_end: "admin"
};
